import createActivityDetector from 'activity-detector';
import { LOG_OUT } from '@/modules/users/store/user.actions';
import store from '@/modules/shared/shared/store';
import router from '@/modules/shared/shared/router';
import { EventBus } from '@/main';
import { EventBusMessages } from '@/modules/shared/shared/domain/constants/event-bus-messages';
export const activityDetector = createActivityDetector({
    timeToIdle: 870000, // wait 15 min of inactivity to consider the user is idle
    ignoredEventsWhenIdle: [],
    inactivityEvents: [],
    autoInit: false,
});

let autoClose;
activityDetector.on('idle', () => {
    if (router.currentRoute.name != 'login') {
        EventBus.$emit(
            EventBusMessages.SHOW_INFO,
            'Se ha detectado un largo período de inactividad dentro del portal por lo que se procederá a cerrar su sesión en 30 segundos a menos que realice una acción',
        );
        autoClose = setTimeout(async () => {
            clearTimeout(autoClose);
            autoClose = null;
            EventBus.$emit(EventBusMessages.SHOW_LOADER);
            await store.dispatch(LOG_OUT);
            EventBus.$emit(EventBusMessages.HIDE_LOADER);
            localStorage.clear();
            router.push({ name: 'login' });
            router.go(0);
        }, 1000 * 30);
    }
});

activityDetector.on('active', () => {
    if (autoClose) {
        clearTimeout(autoClose);
        autoClose = null;
    }
});
